import api from './api-backend';
import { PropertiesResponse, PropertyResponse, PropertyUpdateRequest } from 'types/property';

const propertyService = {
  getMyProperties: async (id: string, perPage?: number): Promise<PropertiesResponse> => {
    const params = new URLSearchParams({ organization_id: id });
    if (perPage) params.set('per_page', String(perPage));
    const response = await api.get(`/v1/properties?${params.toString()}`);
    return response.data;
  },

  getPropertyById: async (propertyId: string): Promise<PropertyResponse> => {
    const response = await api.get(`/v1/properties/${propertyId}`);
    return response.data;
  },

  createProperty: async (data: PropertyUpdateRequest): Promise<PropertyResponse> => {
    const response = await api.post('/v1/properties', data);
    return response.data;
  },

  // Note: For super admin creating property for specific organization,
  // use the standard createProperty endpoint. Backend will use the context
  // or we can pass organization_id in request body if backend supports it
  createPropertyForOrganization: async (organizationId: string, data: PropertyUpdateRequest): Promise<PropertyResponse> => {
    // For now, use standard endpoint - backend needs to be updated to support organization_id override
    const response = await api.post('/v1/properties', {
      ...data,
      organization_id: organizationId,
    });
    return response.data;
  },

  updateProperty: async (id: string, data: PropertyUpdateRequest): Promise<PropertyResponse> => {
    const response = await api.put(`/v1/properties/${id}`, data);
    return response.data;
  },

  deleteProperty: async (id: string): Promise<PropertyResponse> => {
    const response = await api.delete(`/v1/properties/${id}`);
    return response.data;
  },
};

export default propertyService;
